<template>
    <el-form
        :model="form"
        label-width="150px"
        class="wrapper-form contractInfo-form"
        :rules="rules"
        ref="form">
        <el-form-item class="item" :md="8" :lg="6" label="组织者">
            <el-input placeholder="请输入内容" v-model="formObj.organizerName" readonly>
                <el-button slot="append" icon="el-icon-search" @click="detailOrganizerName()"></el-button>
            </el-input>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="分公司" prop="companyName">
            <mInput :params="companyNameData" @getAdvanceValue="getCompanyName" :mValue="formObj.companyName"></mInput>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="服务平台" prop="siteName">
            <mInput :params="siteNameData" @getAdvanceValue="getsiteName" :formData="siteFormData" :mValue="formObj.siteName"></mInput>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="经营中心" prop="centerName">
            <el-input v-model="formObj.centerName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="报名截止时间" prop="signUpEndTime">
            <el-date-picker
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptionsOhterStart"
                v-model="formObj.signUpEndTime"
                type="datetime"
                placeholder="0000-00-00 00:00">
            </el-date-picker>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="标书购买开始时间" prop="purchaseStartTime">
            <el-date-picker
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptionsOhterStart"
                v-model="formObj.purchaseStartTime"
                type="datetime"
                placeholder="0000-00-00 00:00">
            </el-date-picker>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="保证金提交截止时间" prop="depositEndTime">
            <el-date-picker
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptionsOhterStart"
                v-model="formObj.depositEndTime"
                type="datetime"
                placeholder="0000-00-00 00:00">
            </el-date-picker>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="报价开始时间" prop="quoteStartTime">
            <el-date-picker
                v-model="formObj.quoteStartTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptionsQuoteStart"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="0000-00-00 00:00">
            </el-date-picker>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="币种" prop="currency">
            <mInput :params="currencyData" @getAdvanceValue="getCurrency" :mValue="formObj.currency"></mInput>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="标书定价(元)" prop="bidPrice">
            <el-input-number
                v-model="formObj.bidPrice"
                controls-position="right"
                :precision="2"
                :step="1"
                :min="0"
                :max="9999999999">
            </el-input-number>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="投标保证金金额(元)" prop="deposit" >
            <el-input-number
                v-model="formObj.deposit"
                controls-position="right"
                :precision="2"
                :step="1"
                :min="0"
                :max="9999999999"
                @change="depositValueChange('deposit')">
            </el-input-number>
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="业务规模(元)" prop="businessScale">
            <div class="business-scale-content">
                <el-input-number
                v-model="formObj.businessScale"
                :disabled="businessScaleDiasbled"
                controls-position="right"
                :precision="2"
                :step="1"
                :min="0"
                :max="9999999999.99">
            </el-input-number>
            <div class="business-scale-myriad" :style="businessScaleDiasbled?'color:#c3c7c7;':''">{{ businessScaleMyriad }} 万元</div>
            </div>
   
        </el-form-item>
        <el-form-item class="item" :md="8" :lg="6" label="专业公司" prop="professionalCompany">
            <MSelect
                :optionNum="'SYS_PROFESSIONAL_COMPANY'"
                :value="formObj.professionalCompany"
                :filterable="true"
                @input="getProfessionalCompany">
            </MSelect>
        </el-form-item>
        <div :rules="rules" :model="form" label-width="150px" class="wrapper-form bottom">
            <el-form-item class="item" :md="8" :lg="6" label="报价小数位" prop="quotePrecision">
                <el-input-number
                    v-model="formObj.quotePrecision"
                    controls-position="right"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="4">
                </el-input-number>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="是否联动定价">
                <MSelect
                    :optionNum="'BID_YES_NO'"
                    :value="formObj.ralationQuote"
                    :filterable="true"
                    @input="getRalationQuote">
                </MSelect>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="最低价是否可见" prop="lowestQuoteVisible">
                <MSelect
                    :optionNum="'BID_YES_NO'"
                    :value="formObj.lowestQuoteVisible"
                    :filterable="true"
                    @input="getLowestQuoteVisible">
                </MSelect>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="是否维护拦标价" prop="blockPriceControl">
                <MSelect
                    :optionNum="'BID_YES_NO'"
                    :value="formObj.blockPriceControl"
                    :filterable="true"
                    @input="getBlockPriceControl">
                </MSelect>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="是否综合评标" prop="syntheticalScore">
                <MSelect
                    :optionNum="'BID_YES_NO'"
                    :value="formObj.syntheticalScore"
                    :filterable="true"
                    @input="getSyntheticalScore">
                </MSelect>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" v-if="isSkillProportion" label="技术分权重(%)" prop="skillProportion">
                <el-input-number
                    v-model="formObj.skillProportion"
                    @change="cpriceProportion"
                    :precision="2"
                    controls-position="right"
                    :step="1"
                    :min="0"
                    :max="100">
                </el-input-number>
            </el-form-item>
            <el-form-item v-if="isSkillProportion" class="item" :md="8" :lg="6" label="商务分权重(%)">
                <el-input-number
                    v-model="formObj.businessProportion"
                    @change="cpriceProportion"
                    :precision="2"
                    controls-position="right"
                    :step="1"
                    :min="0"
                    :max="100">
                </el-input-number>
            </el-form-item>
            <!-- 附加分权重 -->
            <el-form-item class="item" :md="8" :lg="6" label="附加分权重(%)" prop="extraProportion">
                <el-input v-model="formObj.extraProportion" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="价格分权重(%)" prop="priceProportion">
                <el-input v-model="formObj.priceProportion" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="单次报价最大出价" prop="priceMax">
                <el-input-number
                    v-model="formObj.priceMax"
                    controls-position="right"
                    :precision="3"
                    :step="1"
                    :min="0"
                    :max="9999999999">
                </el-input-number>
            </el-form-item>
            <!-- <el-form-item class="item" :md="8" :lg="6" label="招议标方案特批" prop="specialPermitFlag">
                <MSelect
                    :optionNum="'BID_YES_NO'"
                    :value="formObj.specialPermitFlag"
                    :filterable="true"
                    @input="getSpecialPermitFlag">
                </MSelect>
            </el-form-item> -->
            <el-form-item class="item" :md="8" :lg="6" label="客户" prop="customerName">
                <el-tooltip class="item" effect="dark" :content="formObj.customerName" placement="top">
                    <div slot="content">
                        <div v-for="item in formObj.customers" :key="item.customerName" class="td-customerName-tooltip-item">{{ item.customerName }}</div>
                    </div>
                    <mInput
                        :params="customerParams"
                        @getAdvanceValue="getCustomerNameName"
                        :formData="{}"
                        :mValue="formObj.customerName"
                        :cacheData="customersCache"
                        :maxSelect="customerParams.max">
                    </mInput>
                </el-tooltip>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="联合招标分公司" prop="unionBidCompanyName">
                <el-tooltip class="item" effect="dark" :content="formObj.unionBidCompanyName" placement="top">
                    <div slot="content">
                        <div v-for="item in formObj.unionBidCompanyList" :key="item.customerCode" class="td-customerName-tooltip-item">{{ item.customerName }}</div>
                    </div>
                    <mInput
                        :params="jointBiddingCompany"
                        @getAdvanceValue="getJointBiddingCompany"
                        :formData="{}"
                        :mValue="formObj.unionBidCompanyName"
                        :cacheData="unionBidCompanyNameCache"
                        :maxSelect="jointBiddingCompany.max">
                    </mInput>
                </el-tooltip>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="档位区间是否防倒挂" prop="priceBarb">
                <MSelect
                    :optionNum="'SRM_YES_NO'"
                    :value="formObj.priceBarb"
                    :filterable="true"
                    @input="getPriceBarb">
                </MSelect>
            </el-form-item>
            <el-form-item class="item" :md="8" :lg="6" label="所属行业" prop="bigIndustryList">
                <MSelect
                    :optionNum="'SYS_SUPPLIER_INDUSTRY'"
                    :multiple="true"
                    collapse-tags
                    :value="bigIndustryList"
                    :filterable="true"
                    @input="getBigIndustry">
                </MSelect>
            </el-form-item>
            <el-form-item v-if="[BUSINESS_TYPE.TRANSPORTATION_NUM, BUSINESS_TYPE.DELIVERY_NUM].includes(formObj.businessType)" class="item" :md="8" :lg="6" label="运作城市" prop="operatingCityCode">
                <AddressSelect
                    v-model="operatingCity"
                    :minLayers="2"
                    :max="20"
                    :noSelectProvince="true"
                    :label="'运作城市'"
                    :placeholder="'运作城市'"
                    :collapseTags="true"
                    :basicProps="{ checkStrictly: false, multiple: true }"
                    @change="getOperatingCity"
                    ></AddressSelect>
            </el-form-item>
            <el-form-item v-if="[BUSINESS_TYPE.TRANSPORTATION_NUM, BUSINESS_TYPE.DELIVERY_NUM].includes(formObj.businessType)" class="item" :md="8" :lg="6" label="主发区域" prop="mainRegion">
                    <AddressSelect
                    v-model="mainRegion"
                    :minLayers="4"
                    :max="5"
                    :label="'主发区域'"
                    :placeholder="'主发区域'"
                    :collapseTags="true"
                    :basicProps="{ checkStrictly: true, multiple: true }"
                    @change="getMainRegion"></AddressSelect>
            </el-form-item>
            <el-form-item v-if="[BUSINESS_TYPE.TRANSPORTATION_NUM, BUSINESS_TYPE.DELIVERY_NUM].includes(formObj.businessType)" class="item" :md="8" :lg="6" label="主发车型" prop="mainTransportCar">
                <el-tooltip class="item" effect="dark" :content="mainTransportCar" placement="top">
                    <srmAdvance
                    :max="10"
                    :params="carTypeAdvConfig"
                    ref="srmAdvance"
                    :mCode="formObj.mainTransportCar"
                    :mValue="mainTransportCar"
                    @getAdvanceValue="getMainTransportCar"
                    />
                </el-tooltip>
            
            </el-form-item>

        </div>
        <div class="contract-center">
            <div class="top">合同信息</div>
            <div
                ref="contract"
                :model="form"
                :rules="rules"
                label-width="150px"
                class="wrapper-form">
                <el-form-item class="item" :md="8" :lg="6" label="会计主体" prop="accountEntity">
                    <mInput :params="accountEntityData" @getAdvanceValue="getAccountEntity" :mValue="formObj.accountEntityName" :disabled="isApvSgSd"></mInput>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="业务类型" prop="businessType">
                    <MSelect
                        :optionNum="'BID_BUSINESS_TYPE'"
                        :value="formObj.businessType"
                        :filterable="true"
                        @input="getBusinessType">
                    </MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="服务方式(仓储)" prop="servicesType" v-if="formObj.businessType === '1'">
                    <MSelect
                        :optionNum="'SRM_CONTRACT_WH_SERVICE_TYPE'"
                        :value="formObj.servicesType"
                        :filterable="true"
                        @input="getServicesType">
                    </MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="服务方式(装卸)" prop="servicesType" v-if="formObj.businessType === '2'">
                    <MSelect
                        :optionNum="'SRM_CONTRACT_HANDLING_SERVICE_TYPE'"
                        :value="formObj.servicesType"
                        :filterable="true"
                        @input="getServicesType">
                    </MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="运输方式" prop="transType"
                    v-if=" formObj.businessType === '3' || formObj.businessType === '4' || formObj.businessType === '5' || formObj.businessType === '10'">
                    <MSelect
                        :optionNum="'BID_OVERSEAS_TRANSPORT_TYPE'"
                        :value="formObj.transType"
                        :filterable="true"
                        @input="getTransType">
                    </MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="合同生效日期" prop="contractEffectiveTime">
                    <el-date-picker
                        v-model="formObj.contractEffectiveTime"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptionsStart"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="date"
                        placeholder="选择日期"
                        @change="startChange($event, formObj.contractEffectiveTime)">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="合同终止日期" prop="contractSuspendTime">
                    <el-date-picker
                        v-model="formObj.contractSuspendTime"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptionsEnd"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="税率" prop="taxRate">
                    <mInput :params="taxRateData" @getAdvanceValue="getTaxRate" :mValue="formObj.taxRate"></mInput>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="现汇比例(%)" prop="cashRation">
                    <el-input-number
                        v-model="formObj.cashRation"
                        @change="cAcceptanceRation"
                        :precision="2"
                        controls-position="right"
                        :step="1"
                        :min="0"
                        :max="100">
                    </el-input-number>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="油卡比例(%)" prop="oilCardRation" v-if="isOilCardRation">
                    <el-input-number
                        v-model="formObj.oilCardRation"
                        @change="cAcceptanceRation"
                        :precision="2"
                        controls-position="right"
                        :step="1"
                        :min="0"
                        :max="100">
                    </el-input-number>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="承兑比例(%)" prop="acceptanceRation">
                    <el-input v-model.number="formObj.acceptanceRation" :disabled="true" maxlength="6"></el-input>
                </el-form-item>
                <el-form-item :class="{hasTips:contractDepositRationShow}" class="item contractDepositRation-item" :md="8" :lg="6" label="合同押金比例(%)" prop="contractDepositRation">
                    <div class="contractDepositRation-content">
                        <el-input-number
                            v-model="formObj.contractDepositRation"
                            :precision="2"
                            controls-position="right"
                            :step="1"
                            :min="0"
                            :max="100"
                            @change="depositValueChange('contractDepositRation')">
                        </el-input-number>
                        <div class="contractDepositRation-tips" v-if="contractDepositRationShow">
                            {{ matchDigitalValueValidRuleData.validDigitalValueMsg }}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="发票类型" prop="invoiceType">
                    <MSelect
                        :optionNum="'BID_INVOICE_TYPE'"
                        :value="formObj.invoiceType"
                        :filterable="true"
                        @input="getInvoiceType">
                    </MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="付款条件" prop="paymentTerms">
                    <MSelect
                        :optionNum="'BID_PAYMENT_TERMS'"
                        :value="formObj.paymentTerms"
                        :filterable="true"
                        @input="getPaymentTerms">
                    </MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="客户类型" prop="customerType">
                    <MSelect
                        :optionNum="'SRM_CONTRACT_IS_GROUP_CUSTOMER'"
                        :value="formObj.customerType"
                        :filterable="true"
                        @input="getCustomerType">
                    </MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="集拼方式" prop="collectTypeCode" v-if="['3','4','5','10'].indexOf(formObj.businessType) > -1 && formObj.needCollect === '1'">
                    <LotsSelect
                        v-model="formObj.collectTypeCode"
                        optionsKey="SYS_COLLECT_TYPE"
                        :filterable="true"
                        multiple
                        collapse-tags
                        @input="getCollectTypeCode">
                    </LotsSelect>
                </el-form-item>
            </div>
        </div>
    </el-form>
</template>
<script>
import contractInfo from './contractInfo.js';
export default contractInfo;
</script>
<style lang="less">
   .td-customerName-tooltip-item {
        margin-bottom: 3px;
    }
.contractInfo-form {
    .item{
        .business-scale-content{
            .el-input-number{
                // width: 100px !important;
            }
            .el-input-number__increase{
                display: none;
            }
            .el-input-number__decrease{
                display: none;
            }
            .el-input-number.is-controls-right .el-input__inner{
                padding-right: 0;
                padding-left: 0;
            }
        }

    }

    .business-scale-myriad{
        // position: absolute;
        // left: 102px;
        // top: 0;
        color: #f96c5f;
        font-size: 16px;
        font-weight: bold;
        white-space:nowrap;
    }

    .contractDepositRation-item {
        &.hasTips{
            height: 40px !important;
        }
        .contractDepositRation-content {
            .contractDepositRation-tips{
                margin-top: 2px;
                width: 100%;
                line-height: 1;
                color: #f96c5f;
                font-size: 12px;
                font-weight: bold;
                white-space:nowrap;
            }
        }
    }
}

</style>